import { EmanetXIstemci, tarayiciJetonDepo } from '@emanetx/sdk';
import { yapilandirma } from './yapilandirma.js';

export const jetonDepo = tarayiciJetonDepo();

export const istemci = new EmanetXIstemci({
  tabanUrl: yapilandirma.apiTabanUrl,
  depo: jetonDepo,
  yenilemeBasarisiz: () => {
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/giris')) {
      window.location.href = '/giris?suresi-doldu=1';
    }
  },
});
